module.exports = __webpack_public_path__ + "img/1145.ab573ce0.gif";